import { useState } from 'react';
import { faqData } from '@/mocks/categories';

export default function FAQSection() {
  const [openIds, setOpenIds] = useState<number[]>([]);

  const toggleFaq = (id: number) => {
    setOpenIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
            常见问题
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            你可能想知道
          </h2>
          <p className="text-foreground-600 text-base">
            关于91short的常见疑问，这里都有答案
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq) => {
            const isOpen = openIds.includes(faq.id);
            return (
              <div
                key={faq.id}
                className="rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden transition-all duration-300"
              >
                <button
                  className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                  onClick={() => toggleFaq(faq.id)}
                >
                  <span className="text-sm md:text-base font-heading font-semibold text-foreground-950 pr-4">
                    {faq.question}
                  </span>
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                    isOpen ? 'bg-primary-100 rotate-45' : 'bg-background-100'
                  }`}>
                    <i className={`text-lg ${isOpen ? 'text-primary-600' : 'text-foreground-500'} ri-add-line`}></i>
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-6 pb-5 text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}